import React from 'react';
import SharedTable from 'shared/ui/Table';
import { useSelector, useDispatch } from 'react-redux';
import { withBreakpoints } from 'react-breakpoints';
import {
  selectIsFetchingExpandedData,
  selectVulnsGroupedData,
  selectVulnsSelected
} from 'store/ManageGeneral/selectors';

import { PropTypes } from 'prop-types';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import { getTrProps, findSelectedVuln } from 'Screens/Contextualization/Manage/components/ManageTable/components/Table/Functions';
import {
  selectVulnRow,
  setShowContextMenu,
  unSelectAllVulns
} from 'store/ManageGeneral/actions';
import { vulnsGeneralSubTableSchema } from '../../schema';

const SubTable = ({ context, row, themeStyles }) => {
  const dispatch = useDispatch();
  const rowCount = get(row, 'original.count', 0);
  const vulnsSelected = useSelector(selectVulnsSelected);
  const isFetchingExpandedData = useSelector(selectIsFetchingExpandedData);
  const groupedData = useSelector((state) => selectVulnsGroupedData(state, row.index));

  const selectRowAction = (row) => dispatch(selectVulnRow({}, row));
  const unSelectAllAction = (row) => dispatch(unSelectAllVulns({}, row));
  const showContextMenuAction = (value, xPos, yPos) => dispatch(setShowContextMenu(value, xPos, yPos));

  const hasGroupedData = !isEmpty(groupedData);
  const emptyState = isFetchingExpandedData ? [''] : [];

  return (
    <SharedTable
      schema={ vulnsGeneralSubTableSchema }
      context={ { ...context, isPivot: false, hasGroupedData } }
      data={ hasGroupedData ? groupedData : emptyState }
      defaultPageSize={ rowCount }
      hideHeader
      // Legacy bug preserved: `themeStyles` (never passed, so undefined) lands in getTrProps' isFetching slot.
      getRowProps={ (rowInfo) => getTrProps(rowInfo, vulnsSelected, selectRowAction, unSelectAllAction, showContextMenuAction, themeStyles) }
      isRowSelected={ (rowInfo) => !!findSelectedVuln(rowInfo, vulnsSelected) }
    />
  );
};

SubTable.propTypes = {
  context: PropTypes.object.isRequired,
  row: PropTypes.object.isRequired
};

export default withBreakpoints(SubTable);
